import axios from "axios";
import { useState } from "react";
import { useSelector } from "react-redux";
import { errorHandeling } from "../errorHandeling";
import apiUrl from "../libs/baseUrl";
import { notifyToast } from "../libs/generalFunctions";

function useFetchEvaluationsExcelFile() {

const token = useSelector(state => state.user.token);

//===State start here===
const [errorInExcelExport,setErrorInExcelExport] = useState(null);

const [loadingExcelFile,setLoadingExcelFile] = useState(false);

//===State end here===


const downloadExcelFile = async()=>{

  let data = { };


  try {
    setLoadingExcelFile(true);
    notifyToast("WAITING","يتم التحميل ...");
    const response = await axios.post(
      `${apiUrl}/evaluations/excel/export`,
       data , 
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
       
         responseType: 'blob'

      }
    );
 

      // Check the response type and content
      const contentType = response.headers['content-type'];
      
      if (!contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
        throw new Error("*ملف الاكسل العائد من السيرفر غير صحيح");
      }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'evaluations.xlsx');
    document.body.appendChild(link);
    link.click();

    // Clean up the temporary elements and URL
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    setErrorInExcelExport(null);
    setLoadingExcelFile(false);
 
    notifyToast("SUCCESS","تمت العملية بنجاح");

  } catch (error) {
    setErrorInExcelExport(errorHandeling(error));
    console.error(error);
    setLoadingExcelFile(false);
    notifyToast("ERROR",errorHandeling(error));
  }


}    

return { downloadExcelFile , loadingExcelFile , errorInExcelExport , setErrorInExcelExport };

}

export default useFetchEvaluationsExcelFile;